import React, { useEffect, useState } from "react";
import { Plus, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, API } from "@/lib/api";
import { AdminShell } from "@/components/admin/AdminShell";
import { Seo } from "@/components/Seo";

export default function AffiliateManager() {
  const [links, setLinks] = useState([]);
  const [summary, setSummary] = useState({});
  const [form, setForm] = useState({ name: "", product_name: "", destination_url: "" });

  const load = () => {
    api.get("/admin/affiliate-links").then((r) => setLinks(r.data));
    api.get("/admin/affiliate-clicks").then((r) => setSummary(r.data.summary || {}));
  };
  useEffect(load, []);

  const create = async (e) => {
    e.preventDefault();
    if (!form.name || !form.destination_url) return toast.error("Name and destination required");
    await api.post("/admin/affiliate-links", form);
    setForm({ name: "", product_name: "", destination_url: "" });
    toast.success("Link created");
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Delete this affiliate link?")) return;
    await api.delete(`/admin/affiliate-links/${id}`);
    toast.success("Deleted"); load();
  };

  const copy = (id) => {
    navigator.clipboard.writeText(`${API}/go/${id}`);
    toast.success("Tracking URL copied");
  };

  return (
    <AdminShell title="Affiliate Links">
      <Seo title="Affiliate Links" noindex />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <form onSubmit={create} className="border border-stone-900 bg-white p-5 space-y-4 h-fit" data-testid="affiliate-form">
          <h3 className="font-mono-pm text-xs tracking-widest uppercase text-[#991B1B]">Add New Link</h3>
          <div>
            <label className="font-mono-pm text-[11px] uppercase text-stone-600 block mb-2">Name (internal)</label>
            <input data-testid="affiliate-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={cls} placeholder="DoorLoop — Signup" />
          </div>
          <div>
            <label className="font-mono-pm text-[11px] uppercase text-stone-600 block mb-2">Product Name</label>
            <input value={form.product_name} onChange={(e) => setForm({ ...form, product_name: e.target.value })} className={cls} placeholder="DoorLoop" />
          </div>
          <div>
            <label className="font-mono-pm text-[11px] uppercase text-stone-600 block mb-2">Destination URL</label>
            <input data-testid="affiliate-url" value={form.destination_url} onChange={(e) => setForm({ ...form, destination_url: e.target.value })} className={cls} placeholder="https://doorloop.com/?ref=..." />
          </div>
          <button type="submit" data-testid="create-affiliate" className="w-full bg-stone-900 text-white py-3 font-mono-pm text-xs tracking-widest uppercase hover:bg-[#991B1B] flex items-center justify-center gap-2"><Plus size={14} /> Create</button>
        </form>

        <div className="lg:col-span-2 border border-stone-900 bg-white overflow-x-auto">
          <table className="w-full min-w-[560px]" data-testid="affiliate-table">
            <thead><tr className="bg-stone-900 text-white font-mono-pm text-[10px] tracking-widest uppercase">
              <th className="text-left p-3">Name</th><th className="text-left p-3">Destination</th>
              <th className="text-center p-3">Clicks</th><th className="text-center p-3">Unique</th><th className="text-right p-3">Actions</th>
            </tr></thead>
            <tbody>
              {links.map((l) => (
                <tr key={l.id} className="border-t border-stone-200">
                  <td className="p-3 font-medium text-stone-900">{l.name}</td>
                  <td className="p-3 font-mono-pm text-xs text-stone-500 max-w-[200px] truncate">{l.destination_url}</td>
                  <td className="p-3 text-center font-mono-pm font-bold">{l.click_count || 0}</td>
                  <td className="p-3 text-center font-mono-pm text-stone-600">{summary[l.id]?.unique ?? 0}</td>
                  <td className="p-3">
                    <div className="flex justify-end gap-2">
                      <button onClick={() => copy(l.id)} title="Copy tracking URL" className="p-2 border border-stone-300 hover:bg-stone-100"><Copy size={14} /></button>
                      <button onClick={() => del(l.id)} title="Delete" className="p-2 border border-stone-300 hover:bg-[#991B1B] hover:text-white"><Trash2 size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
              {links.length === 0 && <tr><td colSpan={5} className="p-8 text-center font-mono-pm text-sm text-stone-400">No affiliate links yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </AdminShell>
  );
}

const cls = "w-full border border-stone-900 px-3 py-2.5 font-sans-pm text-sm focus:outline-none";
